"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  public: {
    filter: 'Filter',
    orderName: 'Order Name',
    code: 'Code',
    InspectionOrderNo: 'Order NO.'
  },
  statutory: {
    button: {
      query: 'Search',
      reset: 'Reset',
      addition: 'Add',
      add: 'Add',
      export: 'Export',
      confirm: 'Confirm',
      save: 'Save',
      saveAndAdd: 'Save & Add',
      submit: 'Submit',
      release: 'Publish',
      cancel: 'Cancel',
      goBack: 'Return',
      operation: 'Operation',
      edit: 'Edit',
      detail: 'Detail',
      delete: 'Delete'
    },
    public: {
      certificate: 'Ship Certificate',
      survey: 'Ship Survey',
      regulation: 'Rule and Regulation',
      pleaseEnter: 'Please Enter',
      mailAddress: 'Email'
    }
  },
  statutoryMonitor: {
    statutoryStatistics: 'statutory Statistics',
    distributionCondition: 'distribution Condition',
    inspectionTracking: 'Inspection Tracking',
    ship: 'Ship',
    inspectionNo: 'Inspection No.',
    inspectionType: 'Inspection Type',
    plannedDate: 'Planned Date',
    completionDate: 'Completion Date',
    status: 'Status',
    paymentStatus: 'Payment Status',
    certificateTracking: 'Certificate Tracking',
    reminder: 'Certificate Expiration Reminder',
    certificateName: 'Certificate Name',
    period: 'Inspection Window Period',
    warning: 'Certificate Expiration Warning',
    expirationDate: 'Expiration Date',
    checkVessel: 'Please enter the vessel',
    qtyCheck: 'Only one ship can be selected for operation'
  },
  certGroup: {
    index: {
      table: {
        groupNameCn: 'Group Name(CN)',
        groupNameEn: 'Group Name(EN)',
        groupName: 'Group Name',
        superior: 'Parent Group',
        dispOrder: 'Display Order',
        lastTime: 'Operate Time',
        lastOperator: 'Operator'
      },
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Certificate',
        menuThree: 'Certificate Group'
      }
    },
    message: {
      saveCertGroupSuccess: 'Save certificate group successfully',
      saveCertGroupFail: 'Save certificate group failed'
    },
    title: {
      groupMgt: 'Certificate Group',
      addItem: 'Add',
      addChildItem: 'Add Child',
      editItem: 'Edit'
    },
    rules: {
      groupCode: 'Please enter the group code',
      groupNameCn: 'Please enter the group name(CN)',
      groupNameEn: 'Please input the gorup name(EN)'
    }
  },
  certificate: {
    common: {
      inUse: 'In Use',
      deptName: 'Cert. Mgt. Dept.',
      managementType: 'Mgt. Type',
      filter: 'Filter',
      certDefineType: 'Mgt. Type',
      certDefineCode: 'Mgt. Code',
      valid: 'Valid',
      sealed: 'Archived',
      dispOrder: 'Display Order',
      dispOrderOne: 'Display Order (List)',
      dispOrderTwo: 'Display Order (Certificates)',
      noData: 'No Data',
      tableNo: '',
      vesselCode: 'Code',
      vesselName: 'Ship Name',
      certNo: 'Cert No.',
      certName: 'Cert. Name',
      certAlias: 'Alias',
      shortName: 'Short Name',
      certNameCn: 'Cert. Name(CN)',
      certNameEn: 'Cert. Name(EN)',
      certCode: 'Cert. Code',
      certGroup: 'Cert. Group',
      certSubGroupOne: 'Cert. 2nd Group ',
      certSubGroupTwo: 'Cert. 3nd Group',
      utn: 'UTN',
      certTerm: 'Interval',
      customType: 'Type',
      vesselGroup: 'Special Req for Vessel Group',
      countryRequire: 'Special Req for Vessel Country/Org',
      criticalFlag: 'Is Critical Cert.',
      isSmallCert: 'Is Small Cert.',
      alertFlag: 'Need Alarm',
      preAlertDay: 'Warning Days',
      certAt: 'Location of Custody',
      issueBy: 'Issue By',
      issueAt: 'Issue At',
      issueDate: 'Issue Date',
      effectiveDate: 'Effective Date',
      expiryDate: 'Expiry Date',
      extendedDate: 'Postponed Until',
      certificateScan: 'Cert. Copy',
      lastSurveyDate: 'Last Survey/Audit Date',
      planSurveyDate: 'Plan Survey/Audit Date',
      surveyFlag: 'Req for Survey/Audit',
      certStatus: 'Cert. Status',
      criticalCert: 'Critical Cert.',
      remark: 'Remark',
      yes: 'Y',
      no: 'N',
      certEditDate: 'Modified Date',
      certEditUser: 'Modified By',
      certEditContent: 'Modified Content',
      readStatus: 'Read Status',
      maintFlag: {
        title: 'Status',
        na: 'N/A',
        noCert: 'Lacking Cert.',
        noSurvey: 'Lacking Survey Plan',
        yes: 'Existing Cert.',
        error: 'Error Cert.',
        frontWarn: 'In Survey Window',
        backWarn: 'Being to Expired',
        overDue: 'Expired.'
      }
    },
    checkRules: {
      certNo: 'Please enter the cert. No.',
      issuedBy: 'Please enter the issued by ',
      issuedAt: 'Please enter the issued at',
      issueDate: 'Please enter the issued date',
      dueDate: 'please enter the expiry date',
      certTerm: 'please enter the cert. interval',
      certAt: 'Pease enter the cert. location',
      effectiveDate: 'Please enter the effective date',
      surveyRemark: 'Please enter the survey desc.',
      planSurveyDate: 'Please enter the plan survey date',
      checkVessel: 'Please enter the vessel',
      checkVesselAndCert: 'Plase select the cert. name',
      checkCertName: 'Please enter the cert. name',
      checkCompany: 'Please select the company',
      checkCertDefineType: 'Please enter the Cert. Type',
      checkCertDefineCode: 'Please enter the Mgt. Code',
      checkDeptId: 'Please select the dept.',
      checkPostId: 'Please select the post',
      checkCertPeriod: 'Please select cert. interval',
      preAlertDay: 'Please enter the alarm date',
      writeCateId: 'Please enter the Cert. No.',
      setUnit: 'Please enter the issuing agency',
      setPlace: 'Please enter the issued place',
      surveyAt: 'Please enter the survey Port',
      checkTackDate: 'Please select the issued date',
      checkExpireDate: 'Please select the expired date ',
      setSavePlace: 'Please enter the location',
      surveyType: 'Please select the survey type'
    },
    message: {
      sealedStatusTip: 'Cert. in archived status cannot be operated',
      checkSurveyListLength: 'The certificate needs to be added with an survey plan',
      checkTimeNoFrist: 'The selected date cannot be earlier than the issued date!',
      checkOnlyOneVessel: 'Only one vessel can be selected for export',
      checkVessel: 'Please select the vessel',
      unknownError: 'Unknown Error',
      required: 'Please enter the required content',
      tips: 'Tip',
      deleteWarnTag: 'Are you sure delete the selected item',
      confirm: 'Ok',
      cancel: 'Cancel',
      deleteSuccess: 'delete successfully',
      deleteFail: 'delete failed',
      deleteCancel: 'Cancel',
      confirmSeal: 'Are you sure to seal the cert.',
      sealSuccess: 'Seal up successfully',
      sealFail: 'Seal up failed',
      sealCancel: 'Cancel',
      checkIssuedDate: '签发日期不能晚于生效日期',
      checkEffectiveDate: '生效日期不能晚于到期日期',
      checkDueDate: '到期日期不能晚于展期',
      checkIssuedDueDate: '签发日期不能晚于到期日期',
      checkPlanSurveyDate1: '计划检验日期不能早于签发日期',
      checkPlanSurveyDate2: '计划检验日期不能早于窗口开始日期',
      checkPlanSurveyDate3: '计划检验日期不能晚于窗口结束日期',
      checkRangeStartDate: '窗口开始日期不能晚于窗口结束日期',
      checkExtendedDate: '展期不能早于窗口结束日期或计划检验日期',
      selectRenewalCert: 'Please selected the old cert.',
      fullTermNotSupport: 'Permanent cert. can not be renewal',
      exportFailed: 'Export excel error',
      certOneLevel: 'Please select the 1st cert. group',
      certTwoLevel: 'Please select the 2st cert. group',
      getCertSurveyDefineFail: 'Getting the survey require failed',
      saveCertSurveyDefineSuccess: 'Save the survey require successfully',
      saveCertSurveyDefineFail: 'Save the survey require failed',
      surveyDefineRepeat: 'The survey require has repeated',
      getCertDeptPostFail: 'Geting dept. & post failed',
      saveCertDeptPostFail: 'Save dept. & post failed ',
      getSurveyDefineListFail: 'Getting survey require list failed',
      saveCertDefineSuccess: 'Save the cert. define successfully',
      saveCertDefineFail: 'Save the cert. define failed',
      getCertDefineFail: 'Getting the cert. define failed',
      autoCreateSurveyFail: 'Create the survey list failed',
      getCertInfoFail: 'Getting the cert. info failed',
      saveCertInfoSuccess: 'Save the cert. info. successfully',
      saveCertInfoFail: 'Save the cert. info. failed',
      saveSurveyDefineSuccess: 'Save the survey require successfully',
      getGroupFail: 'Getting the cert. group failed',
      getSurveyFail: 'Getting the survey Info. failed',
      getSurveyListFail: 'Getting the survey list failed',
      savedSurveySuccess: 'Save the survey list successfully',
      savedSurveyFail: 'Save the survey info. failed',
      getDefectFail: 'Getting the defect failed',
      getDefectListFail: 'Getting the defect list failed',
      defectRequireWarn: 'Please enter the defect desc.',
      defectCloseWarn: 'Please enter the defect status',
      defectLimitWarn: 'Please enter the deadline',
      savedDefectSuccess: 'Save the defect info. successfully',
      savedDefectFail: 'Save the defect info. failed'
    },
    certInfo: {
      index: {
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate Mgt.',
          menuThree: 'Certificate Maint.'
        },
        filter: {
          all: 'All',
          inUse: 'In Use',
          invalid: 'Invalid',
          sealed: 'Archived',
          noWarning: 'Normal',
          firstRange: 'Alarm',
          secondRange: 'Immediate Overdue',
          overdue: 'Overdue',
          keyword: 'keyword',
          keywordTag: 'Please enter cert. name or cert. no.',
          filter: 'Filter',
          certGroup: 'Cert. Group ',
          certSubGroupOne: 'Cert. 2nd Group',
          certSubGroupTwo: 'Cert. 3nd Group'
        },
        button: {
          seal: 'Archive',
          renewal: 'Renewal',
          createSurveyList: 'Create Survey List',
          exportCertList: 'Export Cert. List',
          exportCertInfo: 'Export vessel Cert.'
        }
      },
      form: {
        title: 'Cert. Info',
        baseInfo: 'General Info.',
        deptPostInfo: 'Dept. & Post in Charge',
        issueInfo: 'Cert. Info.',
        surveyInfo: 'Survey Info.',
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate',
          menuThree: 'Certificate Maint.',
          menuFour: 'Survey Mgt.',
          menuFive: 'Defect Mgt.'
        },
        survey: {
          title: 'Survey Info.',
          baseInfo: 'Survey Info.',
          surveyRemark: 'Survey Desc.',
          planSurveyDate: 'Plan Date',
          rangeDate: 'Range Date',
          rangeStartDate: 'Plan Start Date',
          rangeEndDate: 'Plan End Date',
          surveyExtendedDate: 'Postponed Util ',
          surveyDate: 'Surveyed Date',
          surveyAt: 'Surveyed Place',
          surveyType: 'Survey Type',
          breadcrumb: {
            surveyInfo: 'Survey Info.',
            defectInfo: 'Defect Info'
          }
        },
        defect: {
          info: 'Defect Record',
          title: 'Defect Info.',
          defectRecord: 'Defect Record',
          defectDesc: 'Defect Desc.',
          limitDate: 'Rectification Deadline',
          preAlertDay: 'Alarm Days',
          defectStatus: 'Status',
          defectOpen: 'Opening',
          defectClose: 'Closed'
        }
      },
      renewalForm: {
        title: 'Renewal',
        baseInfo: 'General Info.',
        oldCertInfo: 'Old Cert.',
        newCertInfo: 'New Cert.'
      },
      btn: {
        record: 'Modified Record'
      }
    },
    certInfoEdit: {
      index: {
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate Mgt.',
          menuThree: 'Certificate Modified Record '
        },
        readStatus: {
          all: 'All',
          read: 'Read',
          toRead: 'To read '
        }
      },
      btn: {
        read: 'Read'
      },
      read: {
        readDate: 'Read Date',
        readUser: 'Read By'
      },
      title: 'Cert. Modified Record'
    },
    certDeptPost: {
      company: 'Company',
      dept: 'Dept.',
      post: 'Post'
    },
    certDefine: {
      index: {
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate',
          menuThree: 'Certificate Dictionary'
        },
        filter: {
          filter: 'Filter',
          certName: 'Cert. Name',
          certGroup: 'Cert. Group ',
          certSubGroupOne: 'Cert. Sub Group One',
          certSubGroupTwo: 'Cert. Sub Group Two',
          keyword: 'keyWord',
          keywordTag: 'Please enter the cert. name'
        }
      },
      form: {
        breadcrumb: {
          menuOne: 'Certificate',
          menuTwo: 'Certificate Dictionary'
        },
        deptPostInfo: 'Dept. & Post ',
        surveyInfo: 'Survey/Audit Info.',
        surveyNameCn: 'Survey/Audit Desc.(Cn)',
        surveyNameEn: 'Survey/Audit Desc.(En)',
        baseFlag: 'Calculated On',
        surveyPeriod: 'Survey/Audit Period',
        rangeStartDay: 'Survey Window Leading Days ',
        rangeEndDay: 'Survey Window Ext. Days',
        month: 'Month',
        day: 'Day',
        effectiveDate: 'Eff. Date',
        expiryDate: 'Exp. Date',
        before: 'Before',
        after: 'After',
        surveyType: 'Survey/Audit Type'
      },
      title: 'Cert. Dictionary',
      certInfo: 'Cert. Info.',
      certOrg: 'Dept.',
      certDefineVessel: 'Vessels of Application Cert.',
      rules: {
        surveyNameCn: 'Please enter the Chinese Name',
        surveyNameEn: 'Please enter the English Name',
        baseFlag: 'Please select the calculation the base value',
        surveyPeriod: 'Please enter the Insp./survey period',
        reservedStr1: 'Please select the window period definition ',
        reservedStr2: 'Please select the window period definition',
        surveyType: 'Please select the calculation the survey type',
        inputDays: 'Please enter the number of days'
      }
    },
    certMonitor: {
      tip: 'Note: clicking the ship name will be finding the cert. monitor details.',
      index: {
        tip: 'Note: Clicking the ship name for displaying the cert. details',
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate',
          menuThree: 'Cert. Monitor Summary'
        },
        company: 'Manager',
        lackCertFlag: 'Cert. Not Maintained',
        lackSurverFlag: 'Cert. Survey Not Maintained',
        table: {
          vessel: 'Ship',
          requireCertQty: 'Nos of Applicable Cert.',
          criticalCertQty: 'Nos of Critical Cert.',
          expiredQty: 'Nos of Expired Cert.',
          beingExpiredQty: 'Nos of Being to Expired Cert.',
          actualCertQty: 'Nos of Cert. Maintained',
          lackCertQty: 'Nos of Cert. Not Maintained',
          lackSurveyQty: 'Nos of Cert. Survey Not Maintained',
          lackCertContent: 'Lack Cert. Name',
          lackCertSurveyContent: 'Lack Survey Name'
        }
      },
      certDefineVessel: {
        breadcrumb: {
          menuOne: 'Statutory',
          menuTwo: 'Certificate',
          menuThree: 'Cert. Monitor Details'
        },
        manage: 'Maint. Cert. for Vessel',
        title: 'Maint. Cert. for Vessel',
        add: 'Add',
        typeFlag: {
          allCert: 'Application Cert.',
          criticalCert: 'Critical Cert.',
          expiredCert: 'Expired Cert.',
          beingExpired: 'Being to Expire Cert.',
          inWindow: 'In Survey Window',
          noCert: 'Lacking Cert.',
          noSurvey: 'Lacking Survey Plan',
          na: 'NA'
        }
      },
      certDefineSelect: {
        title: 'Cert. for Vessel',
        status: 'Status',
        message: {
          selectCert: 'Please select the cert.',
          addSuccess: 'Saving Successfully'
        }
      }
    }
  },
  surveyItem: {
    index: {
      noData: 'No Data',
      tableNo: 'No.',
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Ship Survey',
        menuThree: 'Survey Item',
        menuFour: 'Survey Item Mgt.'
      }
    },
    tabItem: {
      itemTitle: 'Survey Item'
    },
    surveyType: {
      typeName: 'Survey Item Type',
      all: 'All',
      class: 'For Class Survey',
      unClass: 'For Non-Class Survey'
    },
    companyName: 'Company Name',
    itemName: 'Survey Item',
    parentItem: 'Parent Item',
    itemNameCn: 'Survey Item(CN)',
    itemNameEn: 'Survey Item(EN)',
    dispOrder: 'Display Order',
    itemUnit: 'Unit',
    itemRemark: 'Remark',
    isDelTips: 'Delete this item?'
  },
  surveyApply: {
    breadcrumbTitle: {
      certificate: 'Ship Certificate',
      survey: 'Ship Survey'
    },
    filter: 'Filter',
    baseInfo: 'General Info.',
    issuingInformation: ' Issuing Information ',
    certificateValidat: 'Cert. Insp./Survey',
    title: {
      checkDate: 'Select Data',
      apply: 'APPLY',
      inquiry: 'ENQUIRY',
      Price: 'COMPARE',
      Order: 'ORDER',
      surveyManage: 'INSP. MANAGEMENT',
      surveyApply: 'INSP. APPLY',
      surveyInquiry: 'INSP. INQUIRY',
      surveyPrice: 'INSP. COMPARISON',
      surveyOrder: 'INSP ORDER',
      surveyTrack: 'TRACKING',
      company: 'Company',
      vessels: 'Ship',
      inspectionCategory: 'Survey Type',
      state: 'Status',
      editTestProject: 'Edit Insp. Item',
      addTestProject: 'Add Insp. Item',
      surveyApplyInfo: '1. Application Info.',
      surveyItem: '2. Survey Items',
      fileList: '3. Attachment',
      approvalInfo: '4. Approval History'
    },
    btn: {
      syncToRFQ: 'Sync To RFQ',
      addition: 'Add'
    },
    message: {
      checkRepairPlanDate: 'Please select dock repair plan',
      surveySubTypeNotEmpty: 'Please Select Survey Sub Type',
      surveySubDeviceNotEmpty: 'Please select device',
      getGroupFail: 'Get Certificate Group Failed',
      obtainFail: 'Get failed',
      getListFail: 'Failed to obtain inspection/Survey list',
      informationSavedSuc: 'Save the Insp./survey successfully.',
      informationSavedFail: ' Failed to save the Insp./survey.',
      synchronizeToRFQ: 'Synchronize to RFQ',
      syncSuccess: 'Synchronization succeeded',
      syncFail: 'Synchronization failed',
      confirmSkip: 'Are you sure to skip vessel approval',
      operateSucceeded: 'Operate Succeeded',
      projectSaveSuc: 'Sava Inspection Items successfully',
      projectSaveFail: ' Failed to save repair items ',
      projectApplySaveFail: ' Failed to save repair application ',
      deleteProjectSuc: 'Delete Repair Items successfully!',
      deleteProjectFail: 'Failed to delete repair items!',
      checkRepairPlan: 'Please choose a repair plan',
      checkCertificateInformat: 'Please select the ship Inspection information!',
      checkSurveyItemInformat: 'Please select the Survey Item information!',
      searchFail: 'Failed to get data',
      editSuc: 'Edit successfully',
      editFail: 'Edit Failed',
      checkVessel: 'Please select the ship',
      checkVVL: 'Please select the Vessel',
      saveSuc: 'Save successfully',
      saveFail: 'Save Failed',
      getFail: 'Failed to get data',
      rejectNode: ' Please select the process node to be rejected.',
      rejectSuc: 'Reject successfully',
      rejectFail: ' Failed to reject.',
      idRequisitionForm: 'The application id was not found, please save it before submitting',
      emailSentSuc: 'The inquiry email was sent successfully!',
      deleteItem: 'Delete the item will also delete all sub-items, are you sure?',
      confirmDeleteItem: 'Are you sure to delete this item',
      deleteCancel: 'Delete Cancel',
      submittedSuc: 'Submit successfully',
      submittedFail: 'Submit Failed',
      deleteSuc: 'Delete successfully',
      deleteFail: 'Delete Failed',
      deleteCencel: 'Delete Cancel',
      commitRecord: 'Do you submit the record?',
      deleteRecord: 'Do you delete the record?',
      tips: 'Notice',
      confirm: 'YES',
      cancel: 'NO',
      approvalOperation: 'Please select the approval option,',
      saveProjectSuc: 'Save Inspection Item successfully.',
      getInformationFail: 'Get Inspection Item Failed',
      saveInformationFail: 'Save Inspection Item Failed',
      inspectionItems: 'Check Inspection Item',
      certInfRelat: 'Custom inspection items are temporarily not correlate certificate information!',
      pleaseSelectPlan: 'Please select the repair/Inspection Plan'
    },
    index: {
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Survey Request'
      },
      filter: {
        ship: 'Ship',
        applyCode: 'Inquiry NO.',
        surveyType: 'Survey Type'
      },
      filterTab: {
        all: 'All',
        draft: 'Draft',
        onApproval: 'Approving',
        finishApproval: 'Approved'
      },
      button: {
        add: 'Add',
        archive: 'Archive',
        applySurvey: 'Survey Apply',
        export: 'Export'
      },
      table: {
        ship: 'Ship Name',
        vesselCode: 'Ship Code',
        applyCode: 'Inquiry NO.',
        surveyType: 'Survey Type',
        planSurveyDate: 'Plan Date',
        shoreFlag: 'Request From',
        applyPerson: 'Requested By',
        applyDate: 'Request Date',
        status: 'Status'
      }
    },
    buttons: {
      save: 'Save',
      submit: 'Submit',
      inquiryMail: 'Inquiry Email',
      fileUpload: 'Attachment',
      skipShipApproval: 'Skip Ship Approval'
    },
    editApply: {
      surveySubType: 'Survey Sub Type',
      surveySubDevice: 'Device',
      title: {
        certificateInformat: 'Cert. Info.',
        inspectInformat: 'Insp./survey Info.',
        editInformat: 'Edit Insp./survey Info.',
        addInformat: 'Add Insp./survey Info.',
        getFail: 'Failed to get data',
        informationSavedSuc: 'Save the Insp./survey successfully!',
        informationSavedFail: ' Failed to save the Insp./survey.',
        certificateClass: 'Cert. Class',
        certificateOne: 'Cert. No.1',
        certificateTwo: 'Cert. No.2',
        certificateDate: 'Cert. Period',
        certificateDateOne: 'Cert. Period No.1',
        certificateDateTwo: 'Cert. Period No.2',
        operation: 'Edit'
      },
      reset: 'Reset',
      vesselCert: 'Ship Cert. List',
      inspectionItems: 'Customer Inspection Items',
      detailTile: 'Application Info.',
      repairItemTile: 'Survey Items',
      attachmentTitle: 'Attachment',
      certName: 'Cert. Name',
      button: {
        addSurveyItem: 'Add Inspection Items',
        addChildItem: 'Add sub-items'
      },
      itemTab: {
        vesselCertItem: 'Ship Cert. Items',
        customItem: 'Customer Items'
      },
      surveyApplyId: 'Requisition ID',
      vesselCode: 'Ship',
      applyCode: 'Inquiry NO.',
      surveyType: 'Survey Type',
      planSurveyDate: 'Planned Survey Date',
      lastSurveyDate: 'Last Survey Date',
      lateSurveyDate: 'PS Deadline',
      lateSpecialSurveyDate: 'SS Deadline ',
      planSurveyPort: 'Planed Survey At',
      estArriveTime: 'ETA',
      estleaveTime: 'ETD',
      dockPlan: 'Dock Repair Plan',
      technicalFlag: 'Equipment Upgrading',
      applyPerson: 'Requested By',
      applyDate: 'Requested On',
      applyRemark: 'Remark',
      itemForm: {
        mainItemId: 'Dock Repair ID',
        mainItemName: 'Dock Items Name',
        itemCode: 'Repair Items No.',
        itemParentCode: 'Parent Item',
        selectRepairItem: 'Select Repair Items',
        repairItemLibrary: 'Repair Item Library',
        custom: 'Customer',
        itemContent: 'Item Content',
        itemAmount: 'Amount',
        itemUnit: 'Unit',
        dsDueDate: 'Cert. Survey Date',
        ssDueDate: 'Next Survey Date',
        lsDueDate: 'Last Survey Date',
        itemPosition: 'Location',
        technicalFlag: 'Equipment Upgrading',
        insuranceFlag: 'Claimable',
        itemRemark: 'Remark',
        devInfoId: 'Device ID',
        devName: 'Device Name',
        devModel: 'Device Model',
        relatedDevice: 'Related Device',
        cancelRelated: 'Unlink',
        devVendorName: 'Device Vendor',
        lastOperator: 'Operated By',
        lastDate: 'Operated On',
        shoreFlag: 'Request From',
        approvalFlag: 'Corp. Approval Flag'
      },
      projectTable: {
        itemCode: 'Item Code',
        itemName: 'item Name'
      },
      itemTable: {
        surveyContent: 'Survey Content',
        mainConfirm: 'Sup. Confirm',
        dueDate: 'Due Date/Window period',
        itemAmount: 'Qty.',
        itemUnit: 'Unit',
        devInfoId: 'Device ID',
        devName: 'Device Name',
        devModel: 'Device Model',
        itemRemark: 'Remark',
        lastSurveyDate: 'Last Survey Date',
        windowPeriod: 'Window period',
        dsDueDate: 'PS Deadline',
        ssDueDate: 'SS Deadline',
        insuranceFlag: 'Claimable',
        safetyFlag: 'Safety Fare',
        technicalFlag: 'Equipment Upgrading',
        addPerson: 'Creator',
        addDate: 'Add Date'
      },
      certTable: {
        vessel: 'Ship',
        certName: 'Cert. Name',
        certNo: 'Cert. No.',
        surveyContent: 'Insp. Content',
        issuedDate: 'Issue Date',
        effectivedate: 'Eff. Date',
        dueDate: 'Exp. Date',
        lastSurveyDate: 'Last Insp. Date',
        nextSurveyDate: 'Next Insp. Date',
        rangeStartDate: 'Windows From',
        rangeEndDate: 'Windows To',
        extendedDate: 'Window Period'
      },
      devTable: {
        devName: 'Device Name',
        devModel: 'Device Model',
        devManufacturer: 'Device Vendor'
      }
    },
    checkRules: {
      itemContent: 'Please enter the item content',
      itemQuantity: 'Please enter the quantity'
    },
    form: {
      checkingInformation: 'Insp./Survey Info.',
      surveyRemark: 'Insp./Survey Description',
      planSurveyDate: 'Planned Insp./Survey On',
      rangeDate: 'Window Period',
      rangeStartDate: 'Window From',
      rangeEndDate: 'Window End',
      surveyExtendedDate: 'Extend Date',
      surveyDate: 'Actual Start On',
      surveyAt: 'Insp./Survey At'
    },
    defectTable: {
      flawInfo: 'Defect Info.',
      flawRecord: 'Defect Record',
      defectDesc: 'Defect Description',
      limitDate: 'Rectification Deadline',
      preAlertDay: 'Remind Leading Days',
      defectStatus: 'Status'
    },
    defectForm: {
      defectDesc: 'Defect Description',
      limitDate: ' Rectification Deadline ',
      preAlertDay: 'Remind Leading Days',
      defectStatus: 'Status'
    },
    defectStatus: {
      on: 'Running',
      off: 'Stopped'
    },
    certForm: {
      certCategory: 'Cert. Category',
      oldBooks: 'Old Books',
      newBooks: 'New Books',
      vessel: 'Ship',
      certNameEn: 'Cert. Name',
      department: 'Responsible Department',
      post: 'Responsible Rank',
      shortName: 'Cert. short name',
      certNameCn: 'Cert. Name(CN)',
      jobs: 'Responsible Rank',
      certGroup: 'Cert. Type',
      certSubGroup1: '2nd Type',
      certSubGroup2: '3rd Type',
      effective: 'Eff. Status',
      countryRequire: 'Applicable State/Org.',
      vesselTeamId: 'Applicable Ship Type',
      smallFlag: 'Sub Cert.',
      alias: 'Cert. Alias',
      certNo: 'Cert. No.',
      utn: 'UTN (Unique Tracking No.)',
      issueBy: 'Issued By',
      issueAt: 'Issued At',
      issueDate: 'Issued On',
      effectiveDate: 'Eff. Date',
      expiryDate: 'Exp. Date',
      extended: 'Extend Date',
      certTerm: 'Cert. Period Type',
      alertFlag: 'Remind',
      preAlertDay: 'Remind Leading Days',
      certAt: 'Storage Location',
      memo: 'Remark'
    },
    surveyTable: {
      surveyRemark: 'Insp./Survey Desc.',
      planSurveyDate: 'Planned Insp./Survey On',
      rangeDate: 'Window Period',
      rangeStartDate: 'Window From',
      rangeEndDate: 'Window End',
      surveyExtendedDate: 'Extend Date',
      surveyDate: 'Insp./Survey Started On',
      surveyAt: 'Insp./Survey At',
      defectStatus: 'Defect Status',
      annualSurvey: 'Within IS'
    }
  },
  surveyInquiry: {
    breadcrumbTitle: {
      certificate: 'Ship Certificate'
    },
    filter: 'filter',
    keyword: 'Key Word',
    setkeyword: 'Enter the keyword',
    apply: {
      poss: 'Agree',
      reject: 'Disagree',
      totalAmount: 'Total Amount:',
      totalAmountOne: '1、When the total amoun <= 3,000 USD ,The approval of the technical supervisor, deputy general manager of technical department.',
      totalAmountTwo: '2、When the total amoun >  3,000 USD ,The approval of the general manager of company technical department. ',
      totalAmountThree: '3、When the total amoun >  20,000 USD , The approval of the assistant general manager and deputy general manager of the company is required.',
      totalAmountFour: '4、When the total amoun >  50,000 USD ,The approval of the general manager of company.',
      totalAmountOneCny: '1、When the total amoun <= 18,000 CNY , The maintenance supervisor and the deputy general manager of maintenance are required.',
      totalAmountTwoCny: '2、When the total amoun >  18,000 CNY , The approval of the general manager of the company is maintenance is required.',
      totalAmountThreeCny: '3、When the total amoun >  120,000 CNY , The approval of the assistant general manager and deputy general manager of the company is required.',
      totalAmountFourCny: '4、When the total amoun >  300,000 CNY , The approval of the general manager of the company is required',
      keyWordFilter: 'Query about inquiry Id. device name',
      keyWordFilterParts: 'Query about spare parts, spare code',
      purchaseManage: 'Purchase Management',
      spareApply: 'Spare Parts Purchase',
      vesselName: 'Ship',
      dept: 'Department',
      applyNo: 'Inquiry No.',
      devName: 'Device Name',
      applyPurpose: 'Application Purpose',
      urgencyVessel: 'Priority',
      urgencyShore: 'Priority(Shore)',
      applyDate: 'Application Date',
      processNodeShow: 'Current Progress',
      option: 'Edit',
      noOrdered: 'No order',
      ordered: 'Have order',
      canceled: 'Cancel',
      all: 'All',
      spare: 'Spare Parts',
      inquiry: 'Inquiry',
      devCode: 'Device Code',
      devModel: 'Device Model',
      devSerialNo: 'Serial No.',
      devMaker: 'Device Vendor',
      applyReason: 'Application Reason',
      etp: 'Delivery Port',
      applyStatus: 'Status',
      electrical: 'Electrical',
      applicant: 'Applicant',
      equipmentType: 'Device type',
      transferStatus: 'Transfer flag',
      transferNo: 'Transfer order id',
      receiveDate: 'Receive(Shore)',
      enquireStatus: 'Inquiry flag',
      memo: 'Remark/Contact information',
      Remark: 'Remark',
      tempSaveNum: 'Temporary Items Amount',
      spareInquiry: 'Spare Parts Inquiry and Quote',
      SendInquiry: 'Inquiry Mail',
      chooseInquirySupplier: 'Select the Inquiry Vendor',
      historSuppliers: 'Historical Vendor',
      supplier: 'Vendor',
      sender: 'Sender',
      receiver: 'Receiver',
      copyTo: 'CC',
      theme: 'Subject',
      emailContent: 'Email Content',
      file: 'Attachment',
      confirm: 'Confirm',
      eta: 'ETA',
      etd: 'ETD',
      tables: {
        seqNo: 'SEQ No.',
        applyQty: 'Qty.',
        centralized: 'Centralized Purchase',
        inquiryQty: 'Inquiry Qty.',
        sendAttach: 'Send Drawing',
        partsName: 'Spare Parts Name',
        partsCode: 'Spare Parts Code',
        partsDrawing: 'Drawing Code',
        drawingItem: 'Drawing Item',
        unit: 'Unit',
        stockQty: 'Stock Qty.',
        unOrderQty: 'Qty. has been applied for but not order',
        unReceiveQty: 'Qty. has been order but not sign',
        minStockQty: 'Safety stock',
        poQty: 'Order Qty.',
        canTransferQty: 'Available Transfer Qty.',
        transferQty: 'Transferred Qty.',
        toTransferQty: 'Transfer Qty.',
        applyRemark: 'Application Remark',
        partsRemark: 'Spare Parts Remark',
        hcbCode: 'Vendor Code(HCB)',
        ripCode: 'Vendor Code',
        ripName: 'Vendor Name',
        ripNameEn: 'Vendor Name(En)',
        ripEmail: 'Email address',
        contacts: 'Contract',
        email1: 'Email address 1',
        email2: 'Email address 2',
        email3: 'Email address 3',
        fileName: 'Attachment Name'
      },
      tips: {
        sparePartsInfo: 'Spare Parts Info.',
        colorTips: 'Colored numbers: The application quantity.  not equal order quantity',
        applyInfo: 'Application',
        partsInfo: 'Spare Parts info.',
        attachment: 'Attachment',
        approveHistory: 'Approval history',
        commonPurchase: 'Common Purchase',
        addSpareTip: 'If you need customer spare parts，Please Notify the shore personnel  '
      },
      buttons: {
        temporary: 'Draft',
        invalid: 'Cancel',
        inquiryMail: 'Inquiry Mail',
        transferApply: 'Create Transfer Order',
        selectParts: 'Select the Spare Parts',
        fileUpload: 'Attachment'
      }
    },
    editApply: {
      priceOpinions: 'Submit Opinion',
      supplier: 'Vendor',
      repairItemTile: 'Survey Items'
    },
    message: {
      checkInquirySupplier: 'Please select the vendor',
      deleteInquiry: 'Do you delete the Inquiry order',
      tips: 'Notice',
      confirm: 'YES',
      cancel: 'NO',
      deleteRecord: 'Do you delete the record',
      submitRecord: 'Do you submit the record',
      submitSuc: 'Submit successfully',
      submitFail: 'Submit Failed',
      rejectNode: 'Please select the start node after submit reject',
      rejectSuc: 'Reject successfully',
      rejectFail: 'Reject Failed',
      delete: 'Delete successfully',
      deleteFail: 'Delete Failed',
      deleteCancel: 'Delete Cancel ',
      submitInquirySuc: 'Submit inquiry successfully',
      submitInquiryFail: 'Submit inquiry Failed',
      gainFail: 'Get Failed',
      searchFail: 'Search Failed',
      offerSaveSuc: 'Save inquiry successfully',
      offerSaveFail: 'Save inquiry Failed',
      exchangeRateNoresults: 'The currency query exchange rate has no results',
      mailSendSuc: 'Send inquiry email successfully!',
      cancelComparison: 'Whether to cancel the comparison re-quotation',
      getInformationFail: 'Get comparison Failed',
      saveProjectsuc: 'Save Repair Items successfully!',
      saveProjectFail: 'Save Repair Items Failed',
      submitPriceSuc: 'Submit Comparison successfully',
      submitPriceFail: 'Submit Comparison Failed',
      checkSupplier: 'Please select the inquiry vendor',
      checkComparisonItems: 'No check comparison item is selected, please select a comparison item',
      mustOneSupplierOffer: 'At least one supplier must have an offer to submit a price comparison.',
      checkApproval: 'Please select the approval Option.'
    },
    content: {
      inquiryList: '1.Inquiry List',
      inquiryInfo: '2.Inquiry Info',
      supplierInfo: '3.Vendor Quotation Info.',
      repairItem: '4.Survey Items',
      mailSendLog: '5. Mail Send Log.',
      fileList: '6. Attachment Info.',
      inquiryWorkflow: '7.Approval History',
      priceComparison: '1.Price Comparison Info.',
      comparisonItem: '2.Inspection Item Comparison',
      approvalInfo: '3.Approval Info.'
    },
    orderEmailDialog: {
      statutoryManagement: 'Statutory Management',
      orderManagement: 'Order Management',
      sendOrderEmail: 'Send Order Email'
    },
    breadcrumb: {
      menuOne: 'Statutory',
      menuTwo: 'Inspection Inquiry',
      menuThree: 'Select Vendor'
    },
    buttons: {
      save: 'Save',
      submit: 'Submit',
      compareSubmit: 'Submit Comparison ',
      cancelCompare: 'Cancel Comparison',
      compareExport: 'Export Comparison',
      inquiryMail: 'Inquiry Email',
      fileUpload: 'Attachment'
    },
    index: {
      priceList: 'Inquiry List',
      title: '',
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Inspection Inquiry'
      },
      filter: {
        ship: 'Ship',
        applyCode: 'Inquiry NO.',
        repairType: 'Repair Type'
      },
      filterTab: {
        all: 'All',
        toInquiry: 'To Inquiry',
        onApproval: 'Inquiring',
        finished: 'Completed',
        cancel: 'Canceled',
        finishApproval: 'Comparison has been Submitted'
      },
      table: {
        dictionary: {
          docking: 'Docking Repair',
          voyageRepair: 'Voyage Repair',
          dockingSon: 'Docking repair sub contract',
          all: 'All',
          draft: 'Draft',
          onApproval: 'Approving',
          finishApproval: 'Approved',
          cancel: 'Cancel',
          shore: 'Initiate From Shore',
          ship: 'Initiate From Ship'
        },
        inquiryCode: 'Inquiry ID',
        vesselCode: 'Ship',
        repairApplyId: 'Application  primary ID',
        applyCode: 'Application ID',
        repairType: 'Repair Type',
        electricFlag: 'Is',
        shoreFlag: 'Application From',
        applyPerson: 'Applicant',
        applyDate: 'Application Date',
        inquiryStatus: 'Status'
      }
    },
    editInquiry: {
      dialogTitle: 'Inquiry details',
      repairItemTile: 'Survey Items',
      inquiryTable: {
        inquiryCode: 'Inquiry ID',
        inquiryStatus: 'Status',
        supplierName: 'Service Provider',
        quotePrice: 'Amount',
        currencyCode: 'Currency',
        currencyRate: 'Rate',
        discount: 'Discount(%)',
        priceAfterDiscount: 'Discounted Amount',
        estStartDate: 'EST Start Date',
        estSurveyDays: 'EST Survey Days',
        status: 'Status'
      },
      inquiryForm: {
        inquiryInfo: 'Inquiry Info.',
        serviceInfo: 'Vendor Quotation Info.',
        vessel: 'Ship',
        inquiryCode: 'Inquire No.',
        inquiryStatus: 'Inquire Status',
        surveyType: 'Survey Type',
        technicalFlag: 'IS Technological Transformation',
        planSurveyDate: 'EST Survey Date',
        currencyLocal: 'Currency',
        planSurveyPort: 'Planned Survey At',
        supplierName: 'Inquiry Vendor',
        inquiryRemark: 'Remark'
      },
      quoteForm: {
        taxRate: 'Tax Rate(%)',
        taxAmount: 'Tax Amount',
        quoteNo: 'Quote NO.',
        quoteDate: 'Quoted On',
        surveyPort: 'Location',
        currencyCode: 'Currency',
        currencyRate: 'Rate',
        quotePrice: 'Quote Total Amount',
        quoteDiscount: 'Total Discount (%)',
        priceAfterDiscount: 'Discounted Amount',
        estStartDate: 'EST Survey Start On',
        realStartDate: 'Actual Survey Start On',
        estEndDate: 'EST Survey Completed On',
        realEndDate: 'Actual Survey Completed On',
        estWorkDays: 'EST Spend Days',
        realWorkDays: 'Actual Work Days',
        supplierRemark: 'Remark'
      },
      itemTable: {
        surveyContent: 'Survey Content',
        mainConfirm: 'Supervisor Confirm',
        dueDate: 'Due/Window Date',
        devName: 'Related Device',
        devModel: 'Device Model',
        itemRemark: 'Others Remarks',
        itemAmount: 'Amount',
        itemUnit: 'Unit',
        unitPrice: 'Unit Price',
        singleDiscount: 'Item Discount (%)',
        discountedAmount: 'Discounted Amount',
        quoteInstruction: 'Quote Instruction'
      }
    },
    compare: {
      common: {
        yes: 'Yes',
        no: 'No',
        false: 'Valid',
        true: 'Invalid',
        safetyCost: 'Safety Production Cost',
        safetyFlag: 'Safety Production Fee Flag',
        safetyCharge: 'Safety Charge',
        safetyReviewStatus: 'Safety Review Status',
        evalAmount: 'Estimated Amount',
        message: {
          updateSuc: 'Update Succeeded',
          updateFail: 'Update Failed'
        }
      },
      message: {
        checkSafeFlag: '请选择是否包含安全生产费',
        checkSafeCharge: '包含安全生产费时，必须有一项修理项勾选安全生产费且选择了具体安全生产费分类',
        verifyCheck: '不包含安全生产费时，修理项目不能存在已勾选安全生产费',
        checkItemSafeFlag: '请选择安全生产费分类',
        changeChargeTip: 'When the business subject is changed, the category of work safety expense will be reassigned according to the configuration information of the business subject. The selected category of work safety fee type will be overwritten. Please note'
      },
      compareExport: 'Export',
      qtaAttachment: 'Attach',
      budget: 'Budget',
      chargeId: 'Business Subject',
      baPercentage: 'Percentage of Budget Amount',
      auditAmount: 'Audit Amount',
      bRemainingAmount: 'Budget surplus',
      quoteTable: {
        taxRate: 'Tax Rate(%)',
        taxAmount: 'Tax Amount',
        supplier: 'Vendor',
        totalAmount: 'Total Price',
        currency: 'Currency',
        discount: 'Total Discount ',
        disAmount: 'Discounted Amount',
        disAmountUSD: 'Discounted Amount(USD)',
        projectAmount: 'Evaluation Amount',
        thisTotalAmount: 'Total amount of this comparison',
        estWorkDays: 'EST Spend days',
        compareFigure: 'Comparison Figure'
      },
      itemTable: {
        specialSign: 'Special Sign',
        surveyContent: 'Survey Content',
        applyAmount: 'Application Amount',
        amount: 'Amount',
        unit: 'Unit',
        select: 'Select',
        insuranceFlag: 'Claimable',
        safetyCostFlag: 'Safety Cost',
        technicalFlag: 'Is Technical Transformation',
        inquiryPrice: 'Unit Price',
        inquiryDiscount: 'Discount (%)',
        discountPrice: 'Discounted Unit Price',
        LowestDiscountPrice: 'Min. Discounted Price',
        totalPriceAfter: 'Discounted Amount',
        quoteRemark: 'Quote Instruction'
      },
      msg: {
        checkTip: 'Please check this supplier first'
      }
    },
    checkRules: {
      checkVessel: 'Please select a ship',
      messageCheck: 'Cannot exceed 100 characters',
      checkMoney: 'Please select the currency',
      effectiveDate: 'Please select date',
      placeSetDate: 'Please enter number of days',
      taxRateCode: 'Please select tax rate',
      estSurveyStartDate: 'Please Select EST Survey Start On',
      estSurveyEndDate: 'Please Select EST Survey Completed On'
    }
  },
  surveyOrder: {
    reInquiry: {
      tip: 'When there are multiple inspection orders, RFQ again. All inspection orders will be cancelled'
    },
    breadcrumbTitle: {
      survey: 'Ship Survey'
    },
    filter: 'filter',
    message: {
      selectOrder: 'Please select the order to be discarded',
      delChild: 'Delete this item will delete all sub-items，do you want to delete this item',
      getFail: 'Get Failed',
      getOrderListFail: 'Get order List Failed',
      searchFail: 'Search Failed',
      saveSuc: 'Save successfully',
      saveFail: 'Save Failed',
      checkoutSuc: 'Order successfully！',
      checkoutFail: 'Order Failed！',
      emailSentSuc: 'Send inquiry email successfully!',
      emailSentFail: 'Send inquiry email Failed!',
      orderCancelledSuc: 'Cancel Order successfully！',
      orderCancelledFail: 'Cancel Order Failed！',
      chargeNameCn: 'Please select the business subject',
      inquiryPage: 'Jump Inquiry page！',
      cancelOrderFail: 'Cancel Order Failed!',
      cancelOrder: 'Do you cancel inspection order?',
      suc: 'successfully',
      delete: 'Delete successfully',
      deleteFail: 'Delete Failed',
      deleteCancel: 'Canceled Delete ',
      canceledOrder: 'Canceled Order',
      deleteRecord: 'Do you delete the record',
      confirmOrder: 'Do you confirm Order',
      tips: 'Notice',
      confirm: 'Yes',
      cancel: 'No'
    },
    content: {
      surveyOrderList: '1.Order List',
      orderInfo: '2.Order Info.',
      surveyItem: '3.Inspection Item',
      mailSendLog: '4. Mail Send Log.',
      fileList: '5. Attachment Info.'
    },
    title: {
      company: 'Company',
      vessel: 'Ship',
      inspectionCategory: 'Insp. Type',
      state: 'Status'
    },
    span: {
      orderList: 'Order List'
    },
    buttons: {
      save: 'Save',
      orderEmail: 'Send Order Email',
      order: 'Confirm Order',
      cancelOrder: 'Cancel Order',
      fileUpload: 'Attachment'
    },
    index: {
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Survey Order'
      },
      filter: {
        vessel: 'Ship'
      },
      filterTab: {
        all: 'All',
        warning: 'Warning',
        expired: 'Expired'
      },
      button: {
        add: 'Add'
      },
      table: {
        vessel: 'Ship',
        vesselCode: 'Ship Code',
        orderCode: 'Order No.',
        surveyType: 'Survey Type',
        surveyCompany: 'Service Provider',
        surveyPort: 'Survey Location',
        estStartDate: 'EST start date',
        realStartDate: 'Started On',
        estEndDate: 'EST Completed on',
        orderDate: 'Order Date',
        endTime: 'Completion Date',
        realEndDate: 'Completed on',
        estSurveyDays: 'EST Days Inspection ',
        realSurveyDays: 'Days Inspection',
        orderStatus: 'Order Status',
        totalOrderAmount: 'Completion Amount',
        orderCurrency: 'Currency',
        orderDiscount: 'Discount(%)',
        discountAmount: 'Discount Amount',
        orderAmountUSD: 'Completion Amount(USD)',
        paymentStatus: 'Payment Status',
        unpay: 'Unpay',
        paying: 'Paying',
        paiedPartial: 'Paied Partial',
        paiedALL: 'Paied ALL'
      }
    },
    editOrder: {
      orderInfo: 'Order Info.',
      surveyItem: 'Survey Items',
      orderTable: {
        orderCode: 'Order No.',
        surveyCompany: 'Service Provider',
        totalQuotePrice: 'Total Quote Amount',
        currencyCode: 'Currency',
        discount: 'Overall Discount(%)',
        currencyRate: 'Rate',
        priceAfterDiscount: 'Discounted Amount',
        estStartDate: 'EST Survey Start On',
        estSurveyDays: 'EST Survey Days',
        status: 'Status'
      },
      orderForm: {
        projectSubject: 'Project Subject',
        vessel: 'Ship',
        orderCode: 'Order No.',
        orderDate: 'Order Date',
        surveyType: 'Survey Type',
        technicalFlag: 'Equipment Upgrading',
        dockType: 'Dock Repair Plan',
        surveyCompany: 'Service Provider',
        surveyProt: 'Survey Port',
        estStartDate: 'EST Survey Start On',
        realStartDate: 'Actual Survey Start On',
        estEndDate: 'EST Survey Completed On',
        realEndDate: 'Actual Survey Completed On',
        realTestDate: 'Actual Survey Days',
        testPlace: 'Survey Port',
        estSurveyDays: 'EST Survey Days',
        realSurveyDays: 'Actual Survey Days',
        currencyCode: 'Currency',
        currencyRate: 'Rate',
        totalQuotePrice: 'Total Price',
        totalAmountUSD: 'Total Price(USD)',
        totalDiscount: 'Total Discount (%)',
        discountedAmount: 'Discounted Amount',
        taxRate: 'Tax rate(%)',
        taxAmount: 'Tax Amount',
        payStatus: 'Pay Status',
        budgetId: 'Budge Subject',
        cav: 'Capital',
        costSource: 'Cost Source',
        orderStatus: 'Order Status',
        orderRemark: 'Remark'
      },
      itemTable: {
        surveyContent: 'Survey Content',
        dueDate: 'Expiry Date/Window period',
        devName: 'Related Device',
        devModel: 'Device Model',
        itemRemark: 'Others Remark',
        itemAmount: 'Amount',
        itemUnit: 'Unit',
        unitPrice: 'Unit Price',
        discount: 'Discount (%)',
        discountedAmount: 'Discounted Amount',
        quoteInstruction: 'Quote Instruction',
        specialSign: 'Special Sign',
        claimFlag: 'Is Claim'
      }
    },
    checkRules: {
      checkVessel: 'Please select a ship',
      orderCode: 'Please enter the Order No.',
      taxRate: 'Please input the tax rate ',
      chargeNameCn: 'Please select the business subject',
      expenseSource: 'Please select cost source',
      expenseDeptId: 'Please select cost department'
    }
  },
  surveyComplete: {
    message: {
      supplierRating: 'Please complete supplier evaluation first',
      allFinish: 'Are you sure all items have been confirm and completed?',
      tips: 'Notice',
      confirm: 'YES',
      cancel: 'No',
      surveyStatus: 'Completion can only be confirmed at the shore end after all projects are accepted and confirmed',
      completeQty: 'The finished quantity of the inspected items cannot be less than 0',
      submitConfirm: 'All items require confirm by shore before completion',
      loginFail: 'Login is timeout, please login again.',
      saveSuc: 'Save successfully',
      saveFail: 'Save Failed',
      getFail: 'Get Failed',
      geiListFail: 'Get Order List Failed',
      specialSigns: 'Special Sign'
    },
    buttons: {
      save: 'Save',
      shipComplete: 'Verification of completion certificate(Ship)',
      shoreComplete: 'Verification of completion certificate(Shore)',
      supplierRating: 'Supplier evaluation',
      fileUpload: 'Attachment',
      cancelOrder: 'Cancel Order'
    },
    additionalProject: 'Additional Survey Item',
    surveyComplete: 'Inspection Completion',
    completeInfo: 'Completion Info.',
    acceptanceItem: 'Survey Acceptance Item',
    completeForm: {
      behalfPayFlag: 'Behalf Pay Type',
      behalfPayAmount: 'Behalf Pay Amount',
      taxRate: 'Tax Rate(%)',
      taxAmount: 'Tax Order Amount',
      shipyardInfo: 'Service Provider',
      addMoney: 'Total Amount Added',
      vesselName: 'Ship Name',
      supplierRating: 'Supplier evaluation',
      supplierName: 'Supplier Name:',
      businessOrder: 'Business ID:',
      vessels: 'Ship:',
      afterService: 'After-ale Service:',
      offerTimely: 'Timeliness of quotation:',
      priceReason: 'Price Rationality:',
      quality: 'Goods/work quality:',
      distribution: 'Timeliness of goods stocking / delivery:',
      averageScore: 'Total Score:',
      remark: 'Remark:',
      surveyOrderList: '1.Order List',
      surveyInfo: '2.Order Info.',
      surveyItem: '3.Inspection Item',
      fileList: '4.Attachment',
      vessel: 'Ship',
      orderCode: 'Order Code',
      orderStatus: 'Order Status',
      surveyType: 'Survey Type',
      technicalFlag: 'Equipment Upgrading',
      estStartDate: 'Planned Start On',
      estEndDate: 'Planned Completed On',
      estSurveyDays: 'EST Survey Days',
      budgetId: 'Budget Subject',
      cav: 'Cpitalization',
      costSource: 'Cost Source',
      payStatus: 'Pay Status',
      dockType: 'Dock Repair Plan',
      orderPrice: 'Completion Amount',
      completeAmount: 'Completion Amount',
      creditAmount: 'Price Reduction ',
      amountPayable: 'Amount Payable',
      currencyCode: 'Currency',
      currencyRate: 'Rate',
      totalPriceDiscount: 'Overall Discount(%)',
      discountFinishAmount: 'Amount Payable After Discount',
      orderAndAddTotalAmount: 'Total Amount Of Orders And Additional Orders',
      shouldPayAftDisTaxAmount: 'Tax Payable',
      shouldPayAftDisTaxAmountLocal: 'Tax Payable (Base Currency)',
      discountedAmount: 'Amount Payable After Discount (USD)',
      surveyCompany: 'Service Provider',
      surveyProt: 'Survey port',
      linkMan: 'Contacts'
    },
    acceptanceTable: {
      surveyContent: 'Insp. Content',
      dueDate: 'Expiry Date/Window Period',
      devName: 'Related Device',
      devModel: 'Device Model',
      acceptanceFlag: 'Acceptance confirmation',
      itemAmount: 'Completed Qty.',
      itemUnit: 'Unit',
      unitPrice: 'Unit Price',
      discount: 'Discount(%)',
      shoreSure: 'Shore Acceptance',
      shoreRemark: 'Shore Remark',
      vesselRemark: 'Ship Remark',
      discountedAmount: 'Completion Amount',
      quoteInstruction: 'Quote Description',
      claimFlag: 'Claimable'
    },
    addToItem: {
      span: {
        addList: 'Additional Survey Order',
        addMoney: 'Total Amount Added'
      },
      repairItem: 'Repair Item',
      addTable: {
        addToBatchNo: 'Lot No.',
        totalAmount: 'Total Amount',
        discount: 'Discount(%)',
        totalAmountAfDis: 'Discounted Amount',
        totalAmountUSD: 'Total Amount',
        additionalPeople: 'Promoter',
        additionalDate: 'Request Date',
        status: 'Status'
      },
      addOrderForm: {
        choiceDate: 'Select Date',
        vesselCode: 'Ship',
        orderCode: 'Lot No.',
        orderStatus: 'Status',
        creator: 'Promoter',
        createDate: 'Request Date',
        currencyId: 'Currency',
        currencyRate: 'Rate',
        orderPrice: 'Total Amount',
        orderDiscount: 'Discount(%)',
        finishAmount: 'Discounted Total Amount',
        orderRemark: 'Remark'
      }
    },
    checkRules: {
      itemContent: 'Please enter the item content',
      itemQuantity: 'Please enter the quantity',
      surveyDateStart: 'Please select the inspection start date',
      surveyDateEnd: 'Please select the inspection completed date',
      surveyAt: 'Please enter the inspection Port'
    }
  },
  statutoryChange: {
    breadcrumbTitle: {
      regulation: 'Rule and Regulation'
    },
    setkeyword: 'Enter the keyword',
    title: {
      personCharge: 'Responsible Person',
      specialSign: 'Special Sign'
    },
    label: {
      statuteNames: 'Regulation Name',
      keyword: 'Key Word'
    },
    message: {
      note: 'Note: the selected company does not support MOC',
      saveSuc: 'Save successfully',
      saveFail: 'Save Failed',
      getFail: 'Get Failed',
      submitSucc: 'Submit successfully',
      submitFail: 'Submit Failed',
      taskIsnull: 'Change task not assigned, whether to continue to submit',
      changeFalseAndTaskNull: 'No tasks have been assigned, do you submit it?',
      checkCompany: 'Please add the applicable company first',
      searchFailed: 'Search Failed',
      SaveBeforeAdding: 'Please save before adding',
      delete: 'Delete  successfully',
      deleteFail: 'Delete Failed',
      deleteCancel: 'Canceled Delete ',
      deleteRecord: 'Do you want to delete the record?',
      changeFail: 'Get Statutory Alterations Failed',
      taskQueryFail: 'Search Task info. Failed',
      vesselsNotEmpty: 'Please choose a ship.',
      testClassNotEmpty: 'Please choose survey type',
      testDateNotEmpty: 'Please select planned survey date',
      tips: 'Notice',
      confirm: 'YES',
      cancel: 'NO',
      getEnddateFail: 'The due date cannot be earlier than the current date'
    },
    span: {
      statutoryChangeInforma: 'Statutory Change info.'
    },
    content: {
      statutoryChange: '1.Statutory Change info.',
      statutoryFile: '2.statutory Attachment',
      taskInfo: '3.Task info.',
      taskFeedback: '4.Task Feedback',
      taskFile: '5.Task Attachment'
    },
    index: {
      breadcrumb: {
        menuOne: 'Statutory',
        menuTwo: 'Rule & Regulation Tracking'
      },
      filter: {
        ship: '',
        repairType: ''
      },
      filterTab: {
        all: 'All',
        unfinished: 'Not Completed',
        finished: 'Completed'
      },
      button: {
        add: 'Add'
      },
      table: {
        regulationStatus: 'Regulation Status',
        statutoryName: 'Statutory Name',
        statutorySources: 'Released By',
        statutoryAbstract: 'Abstract',
        initiationDate: 'Planned Start Date',
        effectiveDate: 'Eff. Date',
        taskProgress: 'Related Task',
        status: 'Status',
        inputPerson: 'Input by',
        inputDate: 'Input On',
        setChangeManage: 'MOC',
        applyNo: 'Change No.',
        changeManagePerson: 'Change Start By'
      }
    },
    editStatutory: {
      statutoryChangeInfo: 'Statutory Tracking Info.',
      dialogTitle: 'Statutory Tracking',
      applicableCompany: 'Applicable Company',
      company: 'Company',
      statutoryForm: {
        company: 'Company',
        yes: 'Y',
        no: 'N',
        statutoryName: 'Regulation Name',
        inputPerson: 'Input By',
        inputDate: 'Input On',
        statutorySources: 'Released By',
        statutoryAbstract: 'Regulatory Abstract',
        effectiveDate: 'Eff. Date',
        changeFlag: 'MOC',
        status: 'Status',
        initiator: 'Start By',
        initiationDate: 'Start On',
        draftDate: 'Draft On',
        mocRemark: 'Change Reason'
      },
      fileTable: {
        fileName: 'File Name',
        uploadPerson: 'Uploaded By',
        uploadDate: 'Uploaded On ',
        Remark: 'Remark'
      },
      taskTable: {
        taskContent: 'Task Description',
        taskPerson: 'Responsible Person',
        initiationDate: 'Start On',
        endDate: 'Deadline',
        taskStatus: 'Status',
        taskRemark: 'Remark'
      }
    },
    taskInfo: {
      dialogTitle: 'Task  info.',
      taskContent: 'Task Description',
      taskPerson: 'Responsible Person',
      endDate: 'Deadline',
      taskRemark: 'Remark'
    },
    checkRules: {
      changeFlag: 'Please select MOC',
      company: 'Please select a company',
      statutoryName: 'Please enter the name of regulation',
      statutorySource: 'Please input the source of regulation',
      effectiveDate: 'Please select date',
      mocUserName: 'Please choose a promoter',
      mocPlanDate: 'Please Choose a start date',
      taskContent: 'Please enter task description',
      userCodeList: 'Please enter a post',
      TaskCompletion: 'Please fill in the process of task'
    }
  },
  taskFeedback: {
    breadcrumbTitle: {
      regulation: 'Rule and Regulation'
    },
    message: {
      searchFailed: 'Search Failed'
    },
    label: {
      all: 'All',
      notFinished: 'Not Complete',
      finished: 'Completed',
      keyword: 'Key Word',
      include: 'Responsible Person/Statutory Name/Task Description'
    },
    title: {
      shipName: 'Ship',
      applyDate: 'Application Date',
      today: 'Today',
      week: 'A Week',
      mounth: 'A month',
      year: 'A year'
    },
    breadcrumb: {
      menuOne: 'Statutory',
      menuTwo: 'Task Tracking'
    },
    index: {
      table: {
        statutoryName: 'Regulation Name',
        taskContent: 'Task Description',
        employeeNameEn: 'Responsible Person',
        initiationDate: 'Initiate Date',
        rangeDateEnd: 'Plan Deadline',
        completeStatus: 'Status',
        completeContent: 'Task completion',
        completeRemark: 'Remark'
      }
    },
    feedbackTracking: {
      trackingDetails: 'Tracking Details',
      statutoryChange: 'Statutory Change info.',
      statutoryForm: {
        statutoryName: 'Regulation Name',
        statutorySources: 'Released By',
        statutoryAbstract: 'Regulatory Abstract',
        effectiveDate: 'Eff. Date',
        changeFlag: 'MOC',
        status: 'Status'
      },
      taskAllocation: 'Task Allocation',
      taskInfo: 'Task info.',
      taskFeedback: 'Task Feedback',
      taskInfoFrom: {
        taskContent: 'Task Description',
        taskPerson: 'Responsible Person',
        endDate: 'Due Date',
        taskRemark: 'Remark',
        completeDate: 'Completed On',
        completeContent: 'Task completion'
      }
    }
  },
  supplierSurveyOrderSummary: {
    breadcrumb: {
      breadcrumbOne: 'Statutory',
      breadcrumbTwo: 'Ship Certificate',
      breadcrumbThree: 'Supplier Survey Order Summary'
    },
    queryCriteria: {
      company: 'Company',
      supplier: 'Supplier',
      queryDate: 'Order Date'
    },
    table: {
      supplier: 'Supplier',
      counter: 'Number Of Times',
      totalAmount: 'Total Amount(Base Currency)'
    }
  }
};